import { createActions, createReducer } from 'reduxsauce'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    setReferenciaConsultaServidoresFuncoesGratificadas: ['referencia'],
    limpaFiltroConsultaServidoresFuncoesGratificadas: [],
    receberFiltroConsultaServidoresFuncoesGratificadas: ['filtroRecebido'],
    setStatusConsultaServidoresFuncoesGratificadas: ['status'],
})

const INITIAL_STATE = {
    referencia: '',
    status: { label: '', value: '' },
}

const setReferencia = (state = INITIAL_STATE, action) => {
    return { ...state, referencia: action.referencia }
}

const limpaFiltro = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

const receberFiltro = (state = INITIAL_STATE, action) => {
    return action.filtroRecebido
}

const setStatus = (state = INITIAL_STATE, action) => {
    return { ...state, status: action.status }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.SET_REFERENCIA_CONSULTA_SERVIDORES_FUNCOES_GRATIFICADAS]: setReferencia,
    [Types.LIMPA_FILTRO_CONSULTA_SERVIDORES_FUNCOES_GRATIFICADAS]: limpaFiltro,
    [Types.RECEBER_FILTRO_CONSULTA_SERVIDORES_FUNCOES_GRATIFICADAS]: receberFiltro,
    [Types.SET_STATUS_CONSULTA_SERVIDORES_FUNCOES_GRATIFICADAS]: setStatus,
})
